import * as View from "../../../src/Containers/Agreements/View.scss";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { ContractType$reflection, Contract$reflection } from "../Invoicee/Common.js";
import { union_type, int32_type, class_type, bool_type, list_type, lambda_type, unit_type, record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import * as react from "react";
import { ErrorModalProps, renderErrorModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { LoadState_zip, loadEffect, getTranslationFrom, LoadState$2 } from "../../Global.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { ButtonKind, wrappedButton, ButtonProps, defaultProps, main } from "../../Components/Button/Button.js";
import { renderModal } from "../../Components/Modals/Choice/Choice.js";
import { min, int32ToString, equals, comparePrimitives, uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { substring, split, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { renderWithButtonProps } from "../../Components/Modals/Standard.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { Agreement$reflection } from "./Model.js";
import { Result_Map, FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { ContractTypeGeneral$reflection } from "../ContractTypeGeneral/Model.js";
import { length, append as append_1, singleton as singleton_1, empty as empty_1, tryFind, map, ofArray as ofArray_1, collect, fold } from "../../fable_modules/fable-library.3.7.20/List.js";
import { FSharpSet__Contains, empty, ofArray, union } from "../../fable_modules/fable-library.3.7.20/Set.js";
import { bind, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { logei, stackClasses, classNames } from "../../Utils.js";
import { separateByThousands } from "../../Utilities/String.js";
import { dotsLoading, SveaIcon, renderSveaIcon, getFileEndingIcon, Size, getMaterialIconBySize, getWrappedMaterialIcon, getMaterialIcon } from "../../ViewUtils.js";
import { error, MessageKind, customMessage } from "../../Components/Message/Message.js";
import { RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { MortgageValueContainerProps, renderMortgageValueContainer } from "../MortgageValue/View.js";
import { FSharpMap__TryFind, map as map_1 } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { Elements_renderCell, renderTHead } from "../../Components/Table/Table.js";
import { ValidatedUrlModule_value, UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { useIsComponentMounted } from "../../Components/Hooks/IsComponentMounted.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";


export class ContractWithDisplay extends Record {
    constructor(Contract, Display) {
        super();
        this.Contract = Contract;
        this.Display = Display;
    }
}

export function ContractWithDisplay$reflection() {
    return record_type("Containers.Agreements.View.ContractWithDisplay", [], ContractWithDisplay, () => [["Contract", Contract$reflection()], ["Display", string_type]]);
}

function maybeRenderErrorModal(getTranslation, state) {
    const matchValue = state[0];
    switch (matchValue.tag) {
        case 1:
        case 2: {
            return react.createElement(react.Fragment, {});
        }
        case 3: {
            return renderErrorModal(new ErrorModalProps(matchValue.fields[0], (_arg) => {
                state[1](new LoadState$2(0));
            }, getTranslation));
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}

const renderConfirmButton = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const showModal = react.useState(false);
    const children_3 = toList(delay(() => append(singleton(main(new ButtonProps(getTranslation("ConfirmAgreement"), defaultProps.Content, (_arg) => {
        showModal[1](true);
    }, defaultProps.Disabled, "confirm-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))), delay(() => {
        const matchValue = showModal[0];
        if (matchValue) {
            let modalBodyHtml;
            const children_1 = [getTranslation("CustomerContract.Invoicee.Agreements.ConfirmAgreementStillValidation")];
            modalBodyHtml = react.createElement("p", {}, ...children_1);
            return singleton(renderModal(getTranslation(""), modalBodyHtml, getTranslation("Common.Cancel"), getTranslation("Common.Confirm"), (_arg_1) => {
                showModal[1](false);
            }, (_arg_2) => {
                props.ConfirmAgreementFn();
                showModal[1](false);
            }));
        }
        else {
            return singleton(react.createElement(react.Fragment, {}));
        }
    }))));
    return react.createElement("div", {}, ...children_3);
}, "confirmModal", uncurry(2, void 0), void 0, "renderConfirmButton", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Agreements\\View.fs", 62);

class ApproveContractProps extends Record {
    constructor(ApproveContractFn) {
        super();
        this.ApproveContractFn = ApproveContractFn;
    }
}

function ApproveContractProps$reflection() {
    return record_type("Containers.Agreements.View.ApproveContractProps", [], ApproveContractProps, () => [["ApproveContractFn", lambda_type(string_type, unit_type)]]);
}

const renderApproveButton = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_1, children_3, arg, inputRecord;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const showModalState = react.useState(false);
    const commentState = react.useState("");
    let modalHtml;
    const matchValue = showModalState[0];
    if (matchValue) {
        let modalBodyHtml;
        const children_5 = [(children_1 = [getTranslation("CustomerContract.Invoicee.Agreements.ApproveContractInfo")], react.createElement("p", {}, ...children_1)), (children_3 = [(arg = getTranslation("CustomerContract.Invoicee.Agreements.ApproveContractReason"), toText(printf("%s:"))(arg))], react.createElement("p", {}, ...children_3)), render_1()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(commentState[0], inputRecord.Type, inputRecord.Classes, (e) => {
            commentState[1](Browser_Types_Event__Event_get_Value(e));
        }, inputRecord.Disabled, inputRecord.LabelText, inputRecord.Id, inputRecord.ValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name)))];
        modalBodyHtml = react.createElement("div", {
            className: "modal__approval-body",
        }, ...children_5);
        const cancelButtonProps = new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg) => {
            showModalState[1](false);
        }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
        const confirmButtonProps = new ButtonProps(getTranslation("Contracts.Mortgage2.ToApprove"), defaultProps.Content, (_arg_1) => {
            props.ApproveContractFn(commentState[0]);
            showModalState[1](false);
        }, (commentState[0]).length === 0, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
        modalHtml = renderWithButtonProps(showModalState[0], new ModalSize(1), getTranslation("CustomerContract.Invoicee.Agreements.ApproveContract"), modalBodyHtml, cancelButtonProps, confirmButtonProps);
    }
    else {
        modalHtml = react.createElement(react.Fragment, {});
    }
    const children_7 = [main(new ButtonProps(getTranslation("ApproveContract"), defaultProps.Content, (_arg_2) => {
        showModalState[1](true);
    }, defaultProps.Disabled, "approve-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), modalHtml];
    return react.createElement("div", {}, ...children_7);
}, void 0, uncurry(2, void 0), void 0, "renderApproveButton", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Agreements\\View.fs", 129);

class ContractTableProps extends Record {
    constructor(Agreements, CanEdit, DragContentContractNr, Contracts, ContractTypes, ConfirmAgreementFn, ApproveContractFn, HasMortgageApprovePrivilege, ContractTypeGenerals, IsAdmin, MortgageBlocked, NoNextInvoice) {
        super();
        this.Agreements = Agreements;
        this.CanEdit = CanEdit;
        this.DragContentContractNr = DragContentContractNr;
        this.Contracts = Contracts;
        this.ContractTypes = ContractTypes;
        this.ConfirmAgreementFn = ConfirmAgreementFn;
        this.ApproveContractFn = ApproveContractFn;
        this.HasMortgageApprovePrivilege = HasMortgageApprovePrivilege;
        this.ContractTypeGenerals = ContractTypeGenerals;
        this.IsAdmin = IsAdmin;
        this.MortgageBlocked = MortgageBlocked;
        this.NoNextInvoice = NoNextInvoice;
    }
}

function ContractTableProps$reflection() {
    return record_type("Containers.Agreements.View.ContractTableProps", [], ContractTableProps, () => [["Agreements", list_type(Agreement$reflection())], ["CanEdit", bool_type], ["DragContentContractNr", string_type], ["Contracts", list_type(Contract$reflection())], ["ContractTypes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ContractType$reflection()])], ["ConfirmAgreementFn", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["ApproveContractFn", lambda_type(int32_type, lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])])))], ["HasMortgageApprovePrivilege", bool_type], ["ContractTypeGenerals", list_type(ContractTypeGeneral$reflection())], ["IsAdmin", bool_type], ["MortgageBlocked", bool_type], ["NoNextInvoice", bool_type]]);
}

const renderContractTable = FunctionComponent_Of_Z5A158BBF((props) => {
    let contractTypeMap, children_51;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const expandedContractState = react.useState(void 0);
    const confirmAgreementState = react.useState(new LoadState$2(0));
    const approveContractState = react.useState(new LoadState$2(0));
    const connectedContractNrs = fold((s, a) => union(s, ofArray(split(defaultArg(a.ContractNrs, ""), [","], null, 0), {
        Compare: comparePrimitives,
    })), empty({
        Compare: comparePrimitives,
    }), props.Agreements);
    const rows = collect((contract) => {
        let statusBallTitleTranslation, children_23, children_9, children_13, children_17, arg_2, children_21, children_19, buttonsHtml, matchValue, children_27, contractTypeMortgageIdWarningHtml, href, children_36, children_30, props_35, children_34, children_32, mortgageValueContainer, children_47, children_45, children_43, children_41, children_39;
        const isExpanded = equals(contract.Contract.ContractNumber, expandedContractState[0]);
        const mortgageApproved = (contract.Contract.IsValid && (!props.NoNextInvoice)) && (!props.MortgageBlocked);
        const isConnectedTranslation = FSharpSet__Contains(connectedContractNrs, int32ToString(contract.Contract.ContractNumber)) ? getTranslation("Common.Yes") : "";
        const statusClasses = classNames(ofArray_1([["mortgage__status", true], ["mortgage__status--active", mortgageApproved], ["mortgage__status--inactive", !mortgageApproved]]));
        let statusElementsHtml;
        const children_4 = map((tupledArg) => {
            const success = tupledArg[1];
            const classes = classNames(ofArray_1([["approval__status", true], ["approval__status--success", success], ["approval__status--warning", !success], ["approval__status--disabled", !tupledArg[2]]]));
            if (success && tupledArg[3]) {
                return react.createElement("span", {});
            }
            else {
                return react.createElement("span", {
                    className: classes,
                }, tupledArg[0]);
            }
        }, ofArray_1([[getTranslation("CreditCheck"), contract.Contract.CreditCheck, contract.Contract.IsCreditCheckMandatory, false], [getTranslation("PayedInvoices"), contract.Contract.PayedInvoices, contract.Contract.IsPayedInvoicesMandatory, false], [getTranslation("Agreements"), contract.Contract.PhysicalContracts, contract.Contract.IsPhysicalContractsMandatory, false], [getTranslation("MortgageAgeInRange"), contract.Contract.AgeInRange, true, false], [getTranslation("MortgageMonthlyValueInRange"), contract.Contract.MonthlyValueInRange, true, false], [getTranslation("Repports.R13_Mortgage.NoNextInvoice"), !props.NoNextInvoice, true, true], [getTranslation("Repports.R13_Mortgage.MortgageBlocked"), !props.MortgageBlocked, true, true]]));
        statusElementsHtml = react.createElement("div", {
            className: "badges",
        }, ...children_4);
        return ofArray_1([(statusBallTitleTranslation = (mortgageApproved ? getTranslation("CustomerContract.Invoicee.Agreements.MortgageApproved") : getTranslation("CustomerContract.Invoicee.Agreements.MortgageNotApproved")), (children_23 = [(children_9 = [react.createElement("span", {
            className: statusClasses,
            title: statusBallTitleTranslation,
        })], react.createElement("td", {
            className: "smallcell",
        }, ...children_9)), react.createElement("td", {
            className: "cell",
        }, contract.Display), (children_13 = [int32ToString(contract.Contract.ContractNumber)], react.createElement("td", {
            className: "cell",
        }, ...children_13)), react.createElement("td", {
            className: "cell",
        }, isConnectedTranslation), (children_17 = [separateByThousands((arg_2 = defaultArg(contract.Contract.MortgageAmount, 0), toText(printf("%.2f"))(arg_2)))], react.createElement("td", {
            className: "cell",
        }, ...children_17)), (children_21 = [(children_19 = [getMaterialIcon(isExpanded ? "expand_less" : "expand_more")], react.createElement("span", {
            className: "d-flex pointer",
        }, ...children_19))], react.createElement("td", {
            className: "smallcell",
            ["data-regression"]: "expander",
        }, ...children_21))], react.createElement("tr", {
            draggable: props.CanEdit,
            onDragStart: (e) => {
                e.dataTransfer.setData(props.DragContentContractNr, int32ToString(contract.Contract.ContractNumber));
            },
            onClick: (_arg) => {
                if (equals(expandedContractState[0], contract.Contract.ContractNumber)) {
                    expandedContractState[1](void 0);
                }
                else {
                    expandedContractState[1](contract.Contract.ContractNumber);
                }
            },
        }, ...children_23))), isExpanded ? ((buttonsHtml = ((matchValue = ((!contract.Contract.IsValid) && props.HasMortgageApprovePrivilege), matchValue ? ((children_27 = [renderConfirmButton({
            ConfirmAgreementFn: () => {
                loadEffect(() => props.ConfirmAgreementFn(contract.Contract.ContractNumber), (arg) => {
                    confirmAgreementState[1](arg);
                });
            },
        }), renderApproveButton(new ApproveContractProps((comment_1) => {
            loadEffect(() => props.ApproveContractFn(contract.Contract.ContractNumber, comment_1), (arg_1) => {
                approveContractState[1](arg_1);
            });
        }))], react.createElement("div", {
            className: "contracts__button-container",
        }, ...children_27))) : react.createElement(react.Fragment, {}))), (contractTypeMortgageIdWarningHtml = ((bind((ct_1) => ct_1.Mortgage.ContractTypeMortgageId, tryFind((ct) => (ct.ContractTypeCode === contract.Contract.ContractTypeCode), props.ContractTypeGenerals)) != null) ? react.createElement(react.Fragment, {}) : customMessage((href = RouterModule_encodeParts(ofArray_1(["Contracts", "ContractType", contract.Contract.ContractTypeCode, "Mortgage"]), 1), (children_36 = [(children_30 = [getTranslation("CustomerContract.Invoicee.Agreements.ContractTypeMortgageIdMissing")], react.createElement("div", {}, ...children_30)), (props_35 = [new HTMLAttr(65, stackClasses(ofArray_1(["d-flex", "align-items-center"]))), new HTMLAttr(94, href)], (children_34 = [(children_32 = [getTranslation("CustomerContract.Invoicee.Agreements.GoToContractTypeMortgage")], react.createElement("span", {
            className: "mr-2",
        }, ...children_32)), getWrappedMaterialIcon("open_in_new")], react.createElement("a", keyValueList(props_35, 1), ...children_34)))], react.createElement("div", {}, ...children_36))), new MessageKind(1))), (mortgageValueContainer = (props.IsAdmin ? renderMortgageValueContainer(new MortgageValueContainerProps(contract.Contract.ContractNumber)) : react.createElement(react.Fragment, {})), (children_47 = [(children_45 = [(children_43 = [(children_41 = [(children_39 = [getTranslation("MortgageApprovalStatus")], react.createElement("strong", {}, ...children_39))], react.createElement("p", {
            className: "m-0",
        }, ...children_41)), contractTypeMortgageIdWarningHtml, buttonsHtml, statusElementsHtml, mortgageValueContainer], react.createElement("div", {
            className: "contracts__expanded-row",
        }, ...children_43))], react.createElement("td", {
            colSpan: 6,
        }, ...children_45))], react.createElement("tr", {}, ...children_47)))))) : react.createElement(react.Fragment, {})]);
    }, (contractTypeMap = map_1((contractTypeCode, contractType) => substring(contractType.Display, 0, min(comparePrimitives, 30, contractType.Display.length)), props.ContractTypes), map((contract_1) => {
        const matchValue_2 = FSharpMap__TryFind(contractTypeMap, contract_1.ContractTypeCode);
        if (matchValue_2 == null) {
            return new ContractWithDisplay(contract_1, contract_1.ContractTypeCode);
        }
        else {
            return new ContractWithDisplay(contract_1, matchValue_2);
        }
    }, props.Contracts)));
    const children_53 = [(children_51 = [renderTHead(ofArray_1(["", getTranslation("ContractType"), getTranslation("Contract"), getTranslation("ContractConnected"), getTranslation("Value"), ""])), react.createElement("tbody", {
        className: "body",
    }, ...rows)], react.createElement("table", {
        className: "agreements-editable-table",
    }, ...children_51)), maybeRenderErrorModal(getTranslation, confirmAgreementState), maybeRenderErrorModal(getTranslation, approveContractState)];
    return react.createElement("div", {
        className: "tables-container__contracts",
        ["data-regression"]: "agreements-contract-table",
    }, ...children_53);
}, "contract-table", uncurry(2, void 0), void 0, "renderContractTable", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Agreements\\View.fs", 363);

class FilesTableProps extends Record {
    constructor(CanEdit, DragContentContractNr, DragContentFiles, Agreements, InvoiceeFilesBaseUrl, ConnectAgreementFn, DeleteConnectionFn, UploadAgreementFn, DeleteAgreementFn) {
        super();
        this.CanEdit = CanEdit;
        this.DragContentContractNr = DragContentContractNr;
        this.DragContentFiles = DragContentFiles;
        this.Agreements = Agreements;
        this.InvoiceeFilesBaseUrl = InvoiceeFilesBaseUrl;
        this.ConnectAgreementFn = ConnectAgreementFn;
        this.DeleteConnectionFn = DeleteConnectionFn;
        this.UploadAgreementFn = UploadAgreementFn;
        this.DeleteAgreementFn = DeleteAgreementFn;
    }
}

function FilesTableProps$reflection() {
    return record_type("Containers.Agreements.View.FilesTableProps", [], FilesTableProps, () => [["CanEdit", bool_type], ["DragContentContractNr", string_type], ["DragContentFiles", string_type], ["Agreements", list_type(Agreement$reflection())], ["InvoiceeFilesBaseUrl", string_type], ["ConnectAgreementFn", lambda_type(string_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])])))], ["DeleteConnectionFn", lambda_type(string_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])])))], ["UploadAgreementFn", lambda_type(string_type, lambda_type(class_type("Browser.Types.Blob", void 0, Blob), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(string_type), string_type], FSharpResult$2, () => [[["ResultValue", list_type(string_type)]], [["ErrorValue", string_type]]])])))], ["DeleteAgreementFn", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))]]);
}

const renderFilesTable = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const connectAgreementState = react.useState(new LoadState$2(0));
    const deleteConnectionState = react.useState(new LoadState$2(0));
    const uploadAgreementState = react.useState(new LoadState$2(0));
    const deleteAgreementState = react.useState(new LoadState$2(0));
    const showDragState = react.useState(false);
    const stopShowDrag = (e_1) => {
        e_1.preventDefault();
        showDragState[1](false);
    };
    const dragDivClasses = classNames(ofArray_1([["drag-parent-base", true], ["drag-parent", showDragState[0]]]));
    const rows = map((agreement) => {
        let _arg, children_13;
        let downloadLink;
        const matchValue = ValidatedUrlModule_create(new UrlKind(0, props.InvoiceeFilesBaseUrl + agreement.InternalFilename));
        if (matchValue.tag === 1) {
            logei(["Cant create url. Error msg: ", matchValue.fields[0]]);
            downloadLink = "";
        }
        else {
            downloadLink = ValidatedUrlModule_value(matchValue.fields[0]);
        }
        const connectedContracts = map((contractNr_3) => {
            let children_3;
            const children_5 = [react.createElement("span", {}, contractNr_3), (children_3 = toList(delay(() => (props.CanEdit ? singleton(getMaterialIconBySize("close", new Size(0))) : singleton(react.createElement(react.Fragment, {}))))), react.createElement("span", {
                className: "contractnr-box",
                onClick: (_arg_1) => {
                    const contractNr_1 = parse(contractNr_3, 511, false, 32) | 0;
                    loadEffect(() => props.DeleteConnectionFn(agreement.InternalFilename, contractNr_1), (arg_1) => {
                        deleteConnectionState[1](arg_1);
                    });
                },
            }, ...children_3))];
            return react.createElement("span", {
                className: "fenixlabel",
            }, ...children_5);
        }, (_arg = agreement.ContractNrs, (_arg != null) ? ofArray_1(split(_arg, [","], null, 0)) : empty_1()));
        let tooltipString;
        const arg_8 = getTranslation("FileUploadedTime");
        const arg_6 = getTranslation("FileUploadedBy");
        const arg_4 = getTranslation("FileName");
        tooltipString = toText(printf("%s: %s\n%s: %s\n%s: %s"))(arg_4)(agreement.Filename)(arg_6)(agreement.UploadedBy)(arg_8)(agreement.Uploadedutc);
        return [ofArray_1([new HTMLAttr(99, agreement.Filename), new HTMLAttr(65, dragDivClasses), new DOMAttr(50, (e_2) => {
            if ((e_2.dataTransfer.types[0]) === props.DragContentContractNr) {
                stopShowDrag(e_2);
                const contractNr = parse(e_2.dataTransfer.getData(props.DragContentContractNr), 511, false, 32) | 0;
                loadEffect(() => props.ConnectAgreementFn(agreement.InternalFilename, contractNr), (arg) => {
                    connectAgreementState[1](arg);
                });
            }
        }), new DOMAttr(48, (e_3) => {
            const e = e_3;
            e.preventDefault();
            if ((e.dataTransfer.types[0]) === props.DragContentContractNr) {
                showDragState[1](true);
            }
        }), new DOMAttr(47, stopShowDrag)]), ofArray_1([react.createElement("span", {
            className: "truncate",
            ["data-toggle"]: "tooltip",
            title: tooltipString,
        }, agreement.Filename), react.createElement("span", {
            className: "connected__contracts",
        }, ...connectedContracts), react.createElement("span", {}, agreement.Uploadedutc), (children_13 = [getWrappedMaterialIcon(getFileEndingIcon(agreement.Filename))], react.createElement("a", {
            href: downloadLink,
            download: agreement.Filename,
            target: "_blank",
            className: "invoice-table__download-pdf",
        }, ...children_13))]), agreement.InternalFilename];
    }, props.Agreements);
    const uploadFileList = (fileList) => {
        if (fileList.length > 0) {
            const file1 = fileList.item(0);
            const content_2 = file1.slice();
            const name = file1.name;
            loadEffect(() => props.UploadAgreementFn(name, content_2), (arg_2) => {
                uploadAgreementState[1](arg_2);
            });
        }
    };
    const stopShowDrag_1 = (e_5) => {
        e_5.preventDefault();
        showDragState[1](false);
    };
    const props_38 = [new HTMLAttr(99, "agreements"), ["data-regression", "agreements-agreements-table"], new HTMLAttr(65, classNames(singleton_1(["drag-parent", showDragState[0]]))), new DOMAttr(2, (e_6) => {
        uploadFileList(e_6.clipboardData.files);
    }), new DOMAttr(50, (e_7) => {
        stopShowDrag_1(e_7);
        uploadFileList(e_7.dataTransfer.files);
    }), new DOMAttr(47, stopShowDrag_1), new DOMAttr(48, (e_8) => {
        const e_4 = e_8;
        e_4.preventDefault();
        if ((e_4.dataTransfer.types[0]) === props.DragContentFiles) {
            showDragState[1](true);
        }
    })];
    const children_35 = toList(delay(() => {
        let headers, rows_2, children_28, children_26;
        return append(singleton((headers = ofArray_1([getTranslation("FileName"), getTranslation("ConnectedContracts"), getTranslation("Date"), ""]), (rows_2 = map((tupledArg) => {
            let children_18;
            const rowId = tupledArg[2];
            const tableCells = map(Elements_renderCell, tupledArg[1]);
            let saveAndCancelIconCell;
            const children_20 = [(children_18 = toList(delay(() => {
                let children_15;
                return props.CanEdit ? singleton((children_15 = [getWrappedMaterialIcon("close")], react.createElement("span", {
                    className: "cell__icon",
                    onClick: (_arg_2) => {
                        ((internalFilename_2) => {
                            loadEffect(() => props.DeleteAgreementFn(internalFilename_2), (arg_3) => {
                                deleteAgreementState[1](arg_3);
                            });
                        })(rowId);
                    },
                }, ...children_15))) : singleton(react.createElement(react.Fragment, {}));
            })), react.createElement("div", {
                className: "cell__icon-wrap",
            }, ...children_18))];
            saveAndCancelIconCell = react.createElement("td", {
                className: "cell",
            }, ...children_20);
            const props_25 = append_1(singleton_1(new HTMLAttr(99, rowId)), tupledArg[0]);
            const children_22 = append_1(tableCells, singleton_1(saveAndCancelIconCell));
            return react.createElement("tr", keyValueList(props_25, 1), ...children_22);
        }, rows), (children_28 = [(children_26 = [renderTHead(headers), react.createElement("tbody", {
            className: "body",
        }, ...rows_2)], react.createElement("table", {
            className: "agreements-editable-table",
        }, ...children_26))], react.createElement("div", {
            id: "dragsub",
        }, ...children_28))))), delay(() => append(singleton(maybeRenderErrorModal(getTranslation, connectAgreementState)), delay(() => append(singleton(maybeRenderErrorModal(getTranslation, deleteConnectionState)), delay(() => append(singleton(maybeRenderErrorModal(getTranslation, uploadAgreementState)), delay(() => append(singleton(maybeRenderErrorModal(getTranslation, deleteAgreementState)), delay(() => {
            let children_32, children_30;
            return ((length(rows) === 0) && props.CanEdit) ? singleton((children_32 = [renderSveaIcon(new SveaIcon(4)), (children_30 = [getTranslation("DropFilesHere")], react.createElement("p", {}, ...children_30))], react.createElement("div", {
                className: "emptytable",
            }, ...children_32))) : singleton(react.createElement(react.Fragment, {}));
        }))))))))));
    }));
    return react.createElement("div", keyValueList(props_38, 1), ...children_35);
}, "agreement-table", uncurry(2, void 0), void 0, "renderFilesTable", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Agreements\\View.fs", 587);

export class AgreementsProps extends Record {
    constructor(MortgageEnabled, HasEditPhysicalContractPrivilege, HasMortgageApprovePrivilege, InvoiceeFilesBaseUrl, MortgageBlocked, NoNextInvoice, IsAdmin, Contracts, ContractTypes, LoadAgreementsFn, ConfirmAgreementFn, ApproveContractFn, BlockMortgageFn, UnblockMortgageFn, ConnectAgreementFn, DeleteConnectionFn, UploadAgreementFn, DeleteAgreementFn, LoadAllContractTypesFn) {
        super();
        this.MortgageEnabled = MortgageEnabled;
        this.HasEditPhysicalContractPrivilege = HasEditPhysicalContractPrivilege;
        this.HasMortgageApprovePrivilege = HasMortgageApprovePrivilege;
        this.InvoiceeFilesBaseUrl = InvoiceeFilesBaseUrl;
        this.MortgageBlocked = MortgageBlocked;
        this.NoNextInvoice = NoNextInvoice;
        this.IsAdmin = IsAdmin;
        this.Contracts = Contracts;
        this.ContractTypes = ContractTypes;
        this.LoadAgreementsFn = LoadAgreementsFn;
        this.ConfirmAgreementFn = ConfirmAgreementFn;
        this.ApproveContractFn = ApproveContractFn;
        this.BlockMortgageFn = BlockMortgageFn;
        this.UnblockMortgageFn = UnblockMortgageFn;
        this.ConnectAgreementFn = ConnectAgreementFn;
        this.DeleteConnectionFn = DeleteConnectionFn;
        this.UploadAgreementFn = UploadAgreementFn;
        this.DeleteAgreementFn = DeleteAgreementFn;
        this.LoadAllContractTypesFn = LoadAllContractTypesFn;
    }
}

export function AgreementsProps$reflection() {
    return record_type("Containers.Agreements.View.AgreementsProps", [], AgreementsProps, () => [["MortgageEnabled", bool_type], ["HasEditPhysicalContractPrivilege", bool_type], ["HasMortgageApprovePrivilege", bool_type], ["InvoiceeFilesBaseUrl", string_type], ["MortgageBlocked", bool_type], ["NoNextInvoice", bool_type], ["IsAdmin", bool_type], ["Contracts", list_type(Contract$reflection())], ["ContractTypes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ContractType$reflection()])], ["LoadAgreementsFn", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Agreement$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(Agreement$reflection())]], [["ErrorValue", string_type]]])]))], ["ConfirmAgreementFn", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["ApproveContractFn", lambda_type(int32_type, lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])])))], ["BlockMortgageFn", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["UnblockMortgageFn", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["ConnectAgreementFn", lambda_type(string_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])])))], ["DeleteConnectionFn", lambda_type(string_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])])))], ["UploadAgreementFn", lambda_type(string_type, lambda_type(class_type("Browser.Types.Blob", void 0, Blob), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(string_type), string_type], FSharpResult$2, () => [[["ResultValue", list_type(string_type)]], [["ErrorValue", string_type]]])])))], ["DeleteAgreementFn", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["LoadAllContractTypesFn", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ContractTypeGeneral$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ContractTypeGeneral$reflection())]], [["ErrorValue", string_type]]])]))]]);
}

export const renderAgreements = FunctionComponent_Of_Z5A158BBF((props) => {
    let mortgageButtonHtml, children_6;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const errorMessageState = react.useState(void 0);
    const agreementsState = react.useState(new LoadState$2(0));
    const contractTypeGeneralsState = react.useState(new LoadState$2(0));
    const isComponentMounted = useIsComponentMounted();
    const loadAgreements = () => {
        const matchValue = agreementsState[0];
        switch (matchValue.tag) {
            case 3: {
                agreementsState[1](new LoadState$2(1));
                break;
            }
            case 2:
            case 1: {
                break;
            }
            default: {
                agreementsState[1](new LoadState$2(1));
            }
        }
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(props.LoadAgreementsFn(), (_arg) => {
            const result = _arg;
            const res = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
            if (isComponentMounted.current) {
                agreementsState[1](res);
            }
            return singleton_2.Zero();
        })));
    };
    react.useEffect(() => {
        loadAgreements();
        loadEffect(() => props.LoadAllContractTypesFn(), (arg_2) => {
            contractTypeGeneralsState[1](arg_2);
        });
    }, []);
    const thenReloadAgreements = (someAsyncFn) => singleton_2.Delay(() => singleton_2.Bind(someAsyncFn, (_arg_2) => {
        let res_1;
        return singleton_2.Return((res_1 = _arg_2, (void Result_Map((_arg_1) => {
            loadAgreements();
        }, res_1), res_1)));
    }));
    const canEdit = props.HasEditPhysicalContractPrivilege;
    const dragContentContractNr = "contractnr";
    let errorMessageHtml;
    const matchValue_1 = errorMessageState[0];
    errorMessageHtml = ((matchValue_1 != null) ? renderErrorModal(new ErrorModalProps(matchValue_1, (_arg_5) => {
        errorMessageState[1](void 0);
    }, getTranslation)) : react.createElement(react.Fragment, {}));
    const matchValue_4 = LoadState_zip(agreementsState[0], contractTypeGeneralsState[0]);
    switch (matchValue_4.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue_4.fields[0].split(""));
        }
        case 2: {
            const agreements_1 = matchValue_4.fields[0][0];
            const children_8 = [(mortgageButtonHtml = (props.MortgageEnabled ? react.createElement(react.Fragment, {}) : (props.HasMortgageApprovePrivilege ? ((!props.MortgageBlocked) ? wrappedButton(new ButtonKind(1), new ButtonProps(getTranslation("StopMortgage"), defaultProps.Content, (_arg_6) => {
                startImmediate(singleton_2.Delay(() => singleton_2.Bind(props.BlockMortgageFn(), (_arg_3) => {
                    const result_2 = _arg_3;
                    if (result_2.tag === 0) {
                        return singleton_2.Zero();
                    }
                    else {
                        errorMessageState[1](result_2.fields[0]);
                        return singleton_2.Zero();
                    }
                })));
            }, defaultProps.Disabled, "agreements-stop-mortgage", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("StartMortgage"), defaultProps.Content, (_arg_7) => {
                startImmediate(singleton_2.Delay(() => singleton_2.Bind(props.UnblockMortgageFn(), (_arg_4) => {
                    const result_3 = _arg_4;
                    if (result_3.tag === 0) {
                        return singleton_2.Zero();
                    }
                    else {
                        errorMessageState[1](result_3.fields[0]);
                        return singleton_2.Zero();
                    }
                })));
            }, defaultProps.Disabled, "agreements-start-mortgage", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))) : react.createElement(react.Fragment, {}))), react.createElement("div", {
                className: "agreements-mortgages__top-row",
                ["data-regression"]: "top-row",
            }, mortgageButtonHtml)), (children_6 = [renderContractTable(new ContractTableProps(agreements_1, canEdit, dragContentContractNr, props.Contracts, props.ContractTypes, (contractNr) => thenReloadAgreements(props.ConfirmAgreementFn(contractNr)), props.ApproveContractFn, props.HasMortgageApprovePrivilege, matchValue_4.fields[0][1], props.IsAdmin, props.MortgageBlocked, props.NoNextInvoice)), renderFilesTable(new FilesTableProps(canEdit, dragContentContractNr, "Files", agreements_1, props.InvoiceeFilesBaseUrl, (filename, contractNr_1) => thenReloadAgreements(props.ConnectAgreementFn(filename, contractNr_1)), (filename_1, contractNr_2) => thenReloadAgreements(props.DeleteConnectionFn(filename_1, contractNr_2)), (name, blob) => thenReloadAgreements(props.UploadAgreementFn(name, blob)), (filename_2) => thenReloadAgreements(props.DeleteAgreementFn(filename_2)))), errorMessageHtml], react.createElement("div", {
                className: "agreements-mortgages__tables-container",
            }, ...children_6))];
            return react.createElement("div", {
                className: "agreements-mortgages",
                ["data-regression"]: "agreements-container",
            }, ...children_8);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, void 0, uncurry(2, void 0), void 0, "renderAgreements", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Agreements\\View.fs", 787);

